import { postSearch } from "../../../request/bsplatform/stock/design/search/post.js";
async function getUnifySelectInventoryRegActivityStocks({ getActivityStock, orgNo }) {
  const innerGetActivityStock = getActivityStock || postSearch;
  const stocks = await innerGetActivityStock([{ marketClassify: orgNo }]) || [];
  return stocks && stocks.reduce((map, { id: stockId, businessId, productId: classifyId, materialsName: classifyName, colours: extraFields, stock: inventoryQty }) => {
    let arr = map.get(businessId);
    !arr && map.set(businessId, arr = []);
    arr.push({
      stockId,
      classifyId,
      classifyName,
      extraFields,
      inventoryQty
    });
    return map;
  }, new Map());
}
export { getUnifySelectInventoryRegActivityStocks };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/business/unifySelectInventory/activity/getRegActivityStocks.js